import React from 'react';
import { animated, useTransition } from 'react-spring';
import { useRefinementsPanelProvider } from './RefinementsPanel.provider';
import { CatalogProductFilters } from '../RefinementFacet/RefinementFacet.types';
import { Box } from '@withjoy/joykit';
import { RefinementFacetList } from '../RefinementFacetList';
import { useIsMounted } from '@shared/utils/hooks/useIsMounted';

export interface RefinementsPanelProps
  extends Readonly<{
    filters: CatalogProductFilters;
    showSkeleton: boolean;
  }> {}

const PANEL_WIDTH = 320;
const RIGHT_OFFSET = 12;
const LEFT_DELTA = -(PANEL_WIDTH + RIGHT_OFFSET);
export const RefinementsPanel: React.FC<RefinementsPanelProps> = (props: RefinementsPanelProps) => {
  const { filters, showSkeleton } = props;
  const { isOpen } = useRefinementsPanelProvider();
  const isMounted = useIsMounted();
  const transitions = useTransition(isOpen, null, {
    from: {
      opacity: 0,
      marginLeft: LEFT_DELTA,
    },
    enter: {
      opacity: 1,
      marginLeft: 0,
    },
    leave: {
      opacity: 0,
      marginLeft: LEFT_DELTA,
    },
    config: {
      clamp: true,
    },
    reset: true,
    // @ts-ignore
    native: true,
    immediate: !isMounted,
  });

  return (
    <>
      {transitions.map(
        ({ key, item, props }) =>
          item && (
            <Box
              as={animated.div}
              key={key}
              __css={{ flex: `0 0 ${PANEL_WIDTH}px`, willChange: 'margin-left, opacity', marginRight: `${RIGHT_OFFSET}px` }}
              style={props}
            >
              <RefinementFacetList
                filters={filters}
                showSkeleton={showSkeleton}
              />
            </Box>
          ),
      )}
    </>
  );
};

RefinementsPanel.displayName = 'RefinementsPanel';
